<template>
  <el-main>
    <h2 class="text-3xl mb-8">New News Item</h2>
    <news-form
      v-if="news"
      :news.sync="news"
      :delete-text="'Reset'"
      @save="save"
      @delete="confirmDelete"
    />
  </el-main>
</template>

<script>
import { format } from 'date-fns'
import NewsForm from '@/admin/components/NewsForm.vue'
import saveNewsMutation from '@/admin/graphql/mutations/save-news-item.gql'

const date = format(new Date(), 'YYYY-MM-DD')

export default {
  name: 'AdminNewsNew',

  metaInfo: {
    title: 'New News'
  },

  components: {
    NewsForm
  },

  data() {
    return {
      news: {
        date,
        text: '',
        thumb: {},
        fake: false
      }
    }
  },

  apollo: {
    $client: 'admin'
  },

  methods: {
    reset() {
      this.news = {
        date,
        text: '',
        thumb: {},
        fake: false
      }
    },

    async save() {
      const mutation = saveNewsMutation
      const variables = {
        id: '',
        news: this.news
      }
      await this.$apollo
        .mutate({ mutation, variables })
        .then(({ data }) => {
          const id = data.saveNewsItem
          this.$message({ message: 'News item saved', type: 'success' })
          this.$bus.$emit('update-news')
          this.$router.push(`/admin/news/${id}`)
        })
        .catch(err => {
          // eslint-disable-next-line no-console
          console.error(err)
        })
    },

    confirmDelete() {
      this.$confirm(`Reset all fields?`, 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })
        .then(() => {
          this.reset()
        })
        .catch(() => {
          this.$message({ type: 'info', message: 'Form reset' })
        })
    }
  }
}
</script>
